import { h } from 'preact';
import { useShopware } from '../shopware/ShopwareContext';
import { formatPrice } from '../shopware/shopwareUtils';
import { URLS } from '../Urls';
import { ShippingTaxHint } from './ShippingTaxHint';

interface CartDrawerTotalProps {
  onClose?: () => void;
}

export const CartDrawerTotal = ({ onClose }: CartDrawerTotalProps) => {
  const { cart, proceedToCheckout } = useShopware();

  if (!cart || !cart.lineItems || cart.lineItems.length === 0) {
    return null;
  }

  const totalPrice = cart.price?.positionPrice || 0;

  const handleViewCart = () => {
    window.location.href = URLS.cart;
  };

  return (
    <div className="shopping-cart-total-buttons pt-0 pt-md-4 px-3 px-md-0 px-lg-4">
      <h4 className="d-flex text-primary mb-0 d-none d-md-block">
        Zwischensumme{' '}
        <span id="shopping-cart-total" className="ms-auto me-1">
          {formatPrice(totalPrice)}
        </span>
        &euro;
      </h4>
      <div className="d-none d-md-block d-lg-none">
        <ShippingTaxHint />
      </div>
      <div className="d-flex flex-column gap-2 py-2 py-md-4">
        <button className="btn btn-primary btn-block" onClick={proceedToCheckout}>
          Zur Kasse
        </button>
        <button className="btn btn-secondary btn-block" onClick={handleViewCart}>
          Warenkorb ansehen
        </button>
      </div>
      {onClose && (
        <div className="text-center d-none d-md-block d-lg-none">
          <button
            className="btn btn-link p-0 fw-light text-primary text-decoration-underline"
            style={{ letterSpacing: '0.02em', fontSize: '1rem' }}
            onClick={onClose}
          >
            Weiter einkaufen
          </button>
        </div>
      )}
    </div>
  );
};
